import { Routes } from '@angular/router';

import { ConfirmationComponent } from '@features/succession/components/confirmation/confirmation.component';
import { DeceasedInformationComponent } from '@features/succession/components/deceased-information/deceased-information.component';
import { DeceasedMoreInformationComponent } from '@features/succession/components/deceased-more-information/deceased-more-information.component';
import { ErrorComponent } from '@features/succession/components/error/error.component';
import { InheritanceInformationComponent } from '@features/succession/components/inheritance-information/inheritance-information.component';
import { NotaryInformationComponent } from '@features/succession/components/notary-information/notary-information.component';
import { ReporterInformationComponent } from '@features/succession/components/reporter-information/reporter-information.component';
import { SummaryComponent } from '@features/succession/components/summary/summary.component';
import { FormStep } from '@features/succession/enums';
import { RoutesPath } from '@features/succession/enums/routes-path.enum';
import { CustomerInformationGuard } from '@features/succession/guards';
import { ApiErrorResolver } from '@features/succession/resolvers';

export const routes: Routes = [
  {
    path: '',
    loadComponent: () =>
      import('./features/succession/succession.component').then((m) => m.SuccessionComponent),
    children: [
      {
        path: RoutesPath.PAGE_1,
        component: DeceasedInformationComponent,
        canActivate: [CustomerInformationGuard],
        data: { savePage: FormStep.ONE, loadPage: FormStep.ONE },
        pathMatch: 'full',
      },
      {
        path: RoutesPath.PAGE_2,
        component: DeceasedMoreInformationComponent,
        canActivate: [CustomerInformationGuard],
        data: { savePage: FormStep.TWO, loadPage: FormStep.TWO },
        pathMatch: 'full',
      },
      {
        path: RoutesPath.PAGE_3,
        component: ReporterInformationComponent,
        canActivate: [CustomerInformationGuard],
        data: { savePage: FormStep.THREE, loadPage: FormStep.THREE },
        pathMatch: 'full',
      },
      {
        path: RoutesPath.PAGE_4,
        component: NotaryInformationComponent,
        canActivate: [CustomerInformationGuard],
        data: { savePage: FormStep.FOUR, loadPage: FormStep.FOUR },
        pathMatch: 'full',
      },
      {
        path: RoutesPath.PAGE_5,
        component: InheritanceInformationComponent,
        canActivate: [CustomerInformationGuard],
        data: { savePage: FormStep.FIVE, loadPage: FormStep.FIVE },
        pathMatch: 'full',
      },
      {
        path: RoutesPath.PAGE_6,
        component: SummaryComponent,
        canActivate: [CustomerInformationGuard],
        data: { savePage: FormStep.SIX, loadPage: FormStep.SIX },
        pathMatch: 'full',
      },
      {
        path: RoutesPath.PAGE_7,
        component: ConfirmationComponent,
        canActivate: [CustomerInformationGuard],
        data: { savePage: FormStep.SEPT, loadPage: FormStep.SEPT },
        pathMatch: 'full',
      },
      {
        path: RoutesPath.PAGE_ERROR,
        component: ErrorComponent,
        resolve: {
          error: ApiErrorResolver,
        },
        pathMatch: 'full',
      },
      { path: '', redirectTo: RoutesPath.PAGE_1, pathMatch: 'full' },
    ],
  },
];
